module.exports = __webpack_public_path__ + "img/service_이동교통산업.0e395ce8.png";